module.exports = __webpack_public_path__ + "media/images/ecalls/04_how_it_works_1-95849736f243ae1e1acf79163a538e38.png";